import React from 'react';

const MAILogo = ({ className = "w-6 h-6" }) => (
  <div className={`${className} flex items-center justify-center`}>
    <img 
      src="https://customer-assets.emergentagent.com/job_milconnect-ai/artifacts/k1z2sycz_MAI_registered.png" 
      alt="MilConnect AI" 
      className="w-full h-full object-contain"
      style={{ filter: 'brightness(1.1)' }}
    />
  </div>
);

export default MAILogo;